<template>
  <b-form-group
    label="E-Posta"
    label-for="email"
  >
    <b-form-input
      id="email"
      v-model="dataItem.email"
      placeholder="E-Posta"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'EmailAddress',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['tenants/dataItem']
    },
  },
}
</script>
